var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("userFavoritesController", [
    "$rootScope",
    "$scope",
    "$document",
    "$window",
    "modalService",
    "favoritesService",
    "storefrontApp.mainContext",
    function (
        $rootscope,
        $scope,
        $document,
        $window,
        modalService,
        favoritesService,
        storefrontAppMainContext
    ) {
        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function () {
                $scope.customer = storefrontAppMainContext.customer;
                if (
                    $scope.customer &&
                    angular.isUndefined($rootscope.favoriteItems)
                ) {
                    $rootscope.favoriteItems = [];
                    $rootscope.favoriteBrands = [];
                    getFavoriteItems();
                    getFavoriteBrands();
                    getFavoritesGroups();
                }
            }
        );

        function checkUserIsRegistered() {
            if ($scope.customer && $scope.customer.isRegisteredUser) {
                return true;
            }
            return false;
        }

        //#region Fav Items

        function getFavoriteItems() {
            if (checkUserIsRegistered()) {
                favoritesService
                    .getUserFavoriteItems($scope.customer.contactId)
                    .then(function (response) {
                        if (response.data.length > 0) {
                            $rootscope.favoriteItems = response.data;
                        } else {
                            $rootscope.favoriteItems = [];
                        }
                    });
            } else {
                $rootscope.favoriteItems = [];
            }
        }

        $scope.isItemInFavorites = function (prodId) {
            if (checkUserIsRegistered()) {
                if (
                    $rootscope.favoriteItems !== null &&
                    angular.isDefined($rootscope.favoriteItems)
                ) {
                    if (
                        $rootscope.favoriteItems.filter(function (item) {
                            return item.itemId === prodId;
                        }).length > 0
                    ) {
                        return true;
                    }
                    return false;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        };

        $scope.updateFavoritesList = function (prodId, grpName, frompage) {
            if (checkUserIsRegistered()) {
                if (angular.isDefined(frompage)) {
                    var favBtn = $document[0].getElementById(
                        "btn_fav_qv_" + prodId
                    );
                } else {
                    var favBtn = $document[0].getElementById(
                        "btn_fav_" + prodId
                    );
                }
                if (angular.isDefined(grpName) && grpName == "") {
                    if (favBtn.classList.contains("show-dd")) {
                        favBtn.classList.remove("show-dd");
                    } else {
                        favBtn.classList.add("show-dd");
                    }
                } else if (angular.isDefined(prodId)) {
                    var isFavorite =
                        $rootscope.favoriteItems.indexOf(prodId) !== -1;
                    favBtn.classList.add("loading");
                    if (isFavorite) {
                        favoritesService
                            .deleteItemFromFavorites(
                                prodId,
                                $scope.customer.contactId,
                                grpName
                            )
                            .then(function (response) {
                                favBtn.classList.remove("show-dd");
                                favBtn.classList.remove("loading");
                                getFavoriteItems();
                                getFavoritesGroups();
                            });
                    } else {
                        favoritesService
                            .addItemToFavorites(
                                prodId,
                                $scope.customer.contactId,
                                grpName
                            )
                            .then(function (response) {
                                favBtn.classList.remove("show-dd");
                                favBtn.classList.remove("loading");
                                getFavoriteItems();
                                getFavoritesGroups();
                            });
                    }
                }
            } else {
                var returnURL =
                    $window.location.pathname + $window.location.search;
                $scope.outerRedirect(
                    $scope.baseUrl +
                        "account/login?returnurl=" +
                        returnURL.replace("&", "%26")
                );
            }
        };

        //#endregion

        // #region Fav Brands
        $scope.isFavoriteBrand = function (brandName) {
            var isFavorite = false;
            if (
                checkUserIsRegistered() &&
                $rootscope.favoriteBrands &&
                $rootscope.favoriteBrands.length > 0
            ) {
                angular.forEach(
                    $rootscope.favoriteBrands,
                    function (favoriteBrand) {
                        if (favoriteBrand.brandName == brandName) {
                            isFavorite = true;
                        }
                    }
                );
            }
            return isFavorite;
        };

        $scope.updateFavoriteBrands = function (brandName, prodId) {
            if (checkUserIsRegistered()) {
                var favBtnElement = null;
                if (angular.isDefined(prodId)) {
                    favBtnElement = $document[0].getElementById(
                        "btn_favb_" + prodId
                    );
                } else {
                    favBtnElement = $document[0].getElementById(
                        "btn_favb_" + brandName.toLowerCase().replace(/ /g, "_")
                    );
                }
                if (angular.isDefined(favBtnElement)) {
                    favBtnElement.classList.add("loading");
                }
                var isFavorite = $scope.isFavoriteBrand(brandName);
                if (isFavorite) {
                    favoritesService
                        .removeBrandFromFavorites(
                            $scope.customer.contactId,
                            brandName
                        )
                        .then(function (response) {
                            getFavoriteBrands(true);
                            if (angular.isDefined(favBtnElement)) {
                                favBtnElement.classList.remove("loading");
                            }
                        });
                } else {
                    favoritesService
                        .addBrandToFavorites(
                            $scope.customer.contactId,
                            brandName
                        )
                        .then(function (response) {
                            getFavoriteBrands(true);
                            if (angular.isDefined(favBtnElement)) {
                                favBtnElement.classList.remove("loading");
                            }
                        });
                }
            } else {
                var returnURL =
                    $window.location.pathname + $window.location.search;
                $scope.outerRedirect(
                    $scope.baseUrl +
                        "account/login?returnurl=" +
                        returnURL.replace("&", "%26")
                );
            }
        };

        function getFavoriteBrands() {
            if (checkUserIsRegistered()) {
                favoritesService
                    .getFavoriteBrands($scope.customer.contactId)
                    .then(function (response) {
                        $rootscope.favoriteBrands = response.data;
                    });
            }
        }
        //#endregion

        // #region Fav groups

        $scope.resetFavoritesGroupForm = function () {
            $scope.favoriteGroupName = "";
            $scope.notification = {};
            $scope.newFavoritesGroupForm.$setPristine();
            $scope.newFavoritesGroupForm.$setUntouched();
        };

        $scope.createFavoritesGroup = function (newFavoritesGroupForm) {
            if (checkUserIsRegistered()) {
                var favoriteGroup = {};
                var isDuplicate = false;
                if (newFavoritesGroupForm.$valid) {
                    angular.forEach(
                        $rootscope.favoriteGroups,
                        function (group) {
                            if (
                                angular.isDefined(group.groupName) &&
                                group.groupName.toLowerCase() ==
                                    $scope.favoriteGroupName.toLowerCase()
                            ) {
                                isDuplicate = true;
                                $scope.notification = {
                                    type: "error",
                                    content:
                                        "List group already exists with same name",
                                };
                            }
                        }
                    );
                    if (!isDuplicate) {
                        favoriteGroup.itemIds = $rootscope.newFavoritesSKU;
                        favoriteGroup.userId = $scope.customer.contactId;
                        favoriteGroup.groupName = $scope.favoriteGroupName;
                        $scope.formLoading = true;
                        favoritesService
                            .updateItemsFavoritesGroup(favoriteGroup)
                            .then(function (response) {
                                $scope.formLoading = false;
                                if (response && response.data) {
                                    getFavoriteItems();
                                    getFavoritesGroups();
                                    $scope.resetFavoritesGroupForm();
                                    $scope.toggleNewFavoritesGroupModal(false);
                                } else {
                                    $scope.notification = {
                                        type: "error",
                                        content:
                                            "An Error occured while creating new group.",
                                    };
                                }
                            });
                    }
                } else {
                    alert("Veuillez soumettre un nom valide");
                }
            } else {
                var returnURL =
                    $window.location.pathname + $window.location.search;
                $scope.outerRedirect(
                    $scope.baseUrl +
                        "account/login?returnurl=" +
                        returnURL.replace("&", "%26")
                );
            }
        };

        $scope.updateItemsFavoritesGroup = function (
            updateItemsFavoritesGroupForm
        ) {
            if (checkUserIsRegistered()) {
                var favoriteGroup = {};
                if (updateItemsFavoritesGroupForm.$valid) {
                    if (angular.isDefined($rootscope.selectedItems)) {
                        favoriteGroup.itemIds =
                            $rootscope.selectedItems.join(",");
                    }
                    favoriteGroup.userId = $scope.customer.contactId;
                    favoriteGroup.groupName = $scope.updatedListName;
                    $scope.updateFormLoading = true;
                    favoritesService
                        .updateItemsFavoritesGroup(favoriteGroup)
                        .then(function (response) {
                            $scope.updateFormLoading = false;
                            if (response && response.data) {
                                $rootscope.selectedItems = undefined;
                                getFavoriteItems(true);
                                getFavoritesGroups(true);

                                // $scope.resetFilters();
                                $scope.resetFavoritesGroupForm();
                                $scope.toggleNewFavoritesGroupModal(false);
                            } else {
                                $scope.updateNotification = {
                                    type: "error",
                                    content:
                                        "An Error occured while creating new group.",
                                };
                            }
                        });
                } else {
                    $scope.notification = {
                        type: "error",
                        content: "Please select valid List",
                    };
                }
            } else {
                var returnURL =
                    $window.location.pathname + $window.location.search;
                $scope.outerRedirect(
                    $scope.baseUrl +
                        "account/login?returnurl=" +
                        returnURL.replace("&", "%26")
                );
            }
        };

        function getFavoritesGroups() {
            if (checkUserIsRegistered()) {
                favoritesService
                    .getFavoritegroups($scope.customer.contactId)
                    .then(function (response) {
                        if (response) {
                            if (response.data.length < 1) {
                                $rootscope.favoriteGroups = [];
                                $rootscope.favoriteGroups.push({
                                    count: 0,
                                    hashKey: "",
                                });
                            } else {
                                $rootscope.favoriteGroups = response.data;
                                if (
                                    $rootscope.favoriteGroups.filter(function (
                                        group
                                    ) {
                                        return (
                                            !angular.isDefined(group.hashKey) ||
                                            group.hashKey == ""
                                        );
                                    }).length < 1
                                ) {
                                    $rootscope.favoriteGroups.splice(0, 0, {
                                        count: 0,
                                        hashKey: "",
                                    });
                                }
                            }
                        }
                    });
            } else {
                $rootscope.favoriteGroups = null;
            }
        }
        $scope.customSortFavDefaultFunction = function (group) {
            if (
                group.groupName === undefined ||
                group.groupName.toLowerCase() === "default"
            ) {
                return -Infinity;
            } else {
                return group.groupName.toLowerCase().charCodeAt(0);
            }
        };

        $scope.toggleNewFavoritesGroupModal = function (status, sku) {
            $rootscope.newFavoritesSKU = sku;
            if (status) {
                modalService.open("favorites-group");
            } else {
                $scope.resetFavoritesGroupForm();
                modalService.close("favorites-group");
                $rootscope.$emit("NewFavoritesGroupModalClosed");
            }
        };

        //#endregion
    },
]);
